import React from 'react';
import ControlItem from './control-item';

interface ControlBarProps {
  controlMenu: {
    image: number;
    threesixtyAndSphere: number;
    embedAndVideo: number;
  };
  onSwipeToIndex: (index: number) => void;
  onFullscreen: () => void;
  countImg: number;
  countSphere: number;
  countVideo: number;
}

const ControlBar = ({
  controlMenu,
  onSwipeToIndex,
  onFullscreen,
  countImg,
  countSphere,
  countVideo,
}: ControlBarProps) => {
  const { image, threesixtyAndSphere, embedAndVideo } = controlMenu;
  return (
    <div data-am-gallerycontrols="">
      <ControlItem
        title="Visa bilder"
        icon="icon-image"
        count={countImg}
        disabled={image < 0}
        onClick={onSwipeToIndex}
        index={image}
      />
      <ControlItem
        title="Visa 360°"
        icon="icon-360"
        count={countSphere}
        disabled={threesixtyAndSphere < 0}
        onClick={onSwipeToIndex}
        index={threesixtyAndSphere}
      />
      <ControlItem
        title="Visa videor"
        icon="icon-play"
        count={countVideo}
        disabled={embedAndVideo < 0}
        onClick={onSwipeToIndex}
        index={embedAndVideo}
      />
      <button
        type="button"
        className="gallery-controls-btn is-fullscreen"
        title="Visa i fullskärm"
        onClick={onFullscreen}
      >
        <span className="gallery-controls-btn-icon">
          <i className="icon-fullscreen no-margin" />
        </span>
      </button>
    </div>
  );
};

export default ControlBar;
